import React, { useEffect, useImperativeHandle, useLayoutEffect, useRef, useState } from "react";
import { Button, Input, Selector } from "../Elements";
import Modal from "../Modal";
import { useDispatch, useSelector } from 'react-redux';
import { toast } from "react-toastify";
import commonNetwork from "../../../common/api/commonNetwork";
import PaymentLinkResultModal from "../PaymentLinkResultModal";
import { isLogoAppProject } from "../../../common/helpers/globalHelpers";
import appHelpers from "../../../common/helpers/appHelpers";
import { customerSelectFrom, postMessageTypes } from "../../../constants/postMessageFileds";
import { TbDots } from "react-icons/tb";
import { clearBankMatchSelect } from "../../../store/slices/erpParameterSlice";
import { erpSyncType } from "../../../constants/erpSyncTypes";
import { postWebViewMessage } from "../../../common/helpers/messageHelper";
import { ApiResponseType } from "../../../common/api/apiHelper";
import { OptionModel } from "../../../common/types/OptionModel";
import { useRecoilValue } from "recoil";
import { tenantState } from "../../../store/recoil/tenant/atoms";

type componentProps = {
    onUpdateOrderErpParameter: Function
}

const initialOptions: OptionModel[] = [{
    value: 0,
    label: ""
}]

const UpdateOrderErpParametersModal = React.forwardRef((props: componentProps, ref) => {

    const linResultModalRef = useRef<any>();

    const { firmInformations } = useRecoilValue(tenantState);

    const { projectCodes, salesmanCodes, referenceCodes } = useSelector((state: any) => state.erpParameters);
    const { erpParameter, selectedErpBankCode } = useSelector((state: any) => state.erpParameters);

    const dispatch = useDispatch();

    const bankErpCodeSelectBoxRef = useRef<any>();
    const { erpContractList } = useSelector((state: any) => state.vpDetail);

    const isReceipt = erpParameter?.netsisParams?.synctypeid == 2 ? true : false;
    const isVirement = erpParameter?.logoParams?.synctypeid == erpSyncType.virement;


    const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
    const [statusModalVisible, setStatusModalVisible] = React.useState(false);
    const [fields, setFields] = useState({
        erpbranchcode: "",
        erpcontractcode: "",
        erpreferencecode: "",
        erpprojectcode: "",
        erpsalesmancode: "",
        orderId: 0,
        erpbankcode: ""
    });
    const [createLoading, setCreateLoading] = useState<boolean>(false);
    const [erpsalesmancodeOptions, setErpsalesmancodeOptions] = useState<OptionModel[]>(initialOptions);
    const [erpprojectcodeOptions, setErpprojectcodeOptions] = useState<OptionModel[]>(initialOptions);
    const [erpreferencecodeOptions, setErpreferencecodeOptions] = useState<OptionModel[]>(initialOptions);
    const [erpcontractcodeOptions, setErpcontractcodeOptions] = useState<OptionModel[]>(initialOptions);
    const [erpbranchcodeOptions, setErpbranchcodeOptions] = useState<OptionModel[]>(initialOptions);


    const isNetsis = firmInformations.erpType == "NETSIS";
    useImperativeHandle(ref, () => ({

        openModal(defaultValues: any) {
            selectErpContractList();
            selectErpParameterList();
            setFields(defaultValues);
            setIsModalVisible(true);
            setCreateLoading(false);
        }
    }));

    useLayoutEffect(() => {
        selectErpContractList();
    }, []);

    useEffect(() => {
        if (bankErpCodeSelectBoxRef.current && selectedErpBankCode?.length > 0) {
            dispatch(clearBankMatchSelect(""))
            bankErpCodeSelectBoxRef.current.setValue(selectedErpBankCode + "");
        }
    }, [selectedErpBankCode]);

    useEffect(() => {
        getErpValues();
    }, [])


    const selectErpParameterList = () => {
        var messageBody = { requestType: postMessageTypes.selectErpParameterList, requestBody: "" };
        postWebViewMessage(JSON.stringify(messageBody));
    }

    const selectErpContractList = () => {
        var messageBody = { requestType: postMessageTypes.selectContractList, requestBody: "" };
        postWebViewMessage(JSON.stringify(messageBody));
    }

    const openCustomerForm = () => {
        var callbackParameters = {
            customerSelectFrom: customerSelectFrom.fromVpInformations
        }
        var messageBody = { requestType: postMessageTypes.getCustomerInfo, requestBody: "", callbackParameters: JSON.stringify(callbackParameters) };
        postWebViewMessage(JSON.stringify(messageBody));
    }

    const openBankListForm = () => {
        if (isVirement && isNetsis != true) {
            openCustomerForm();
        } else
            var messageBody: any = {
                requestType: postMessageTypes.openErpBankList,
                requestBody: (isReceipt) ? "true" : "false",
            };
        postWebViewMessage(JSON.stringify(messageBody));
    }

    const onUpdateClick = async () => {
        if (fields.erpbankcode.length <= 50) {
            setCreateLoading(true);
            const params = {
                orderid: fields.orderId,
                branchCode: fields.erpbranchcode,
                erpContractCode: fields.erpcontractcode,
                projectCode: fields.erpprojectcode,
                referenceCode: fields.erpreferencecode,
                salesmanCode: fields.erpsalesmancode,
                erpBankCode: fields.erpbankcode
            }
            const response = await commonNetwork.post("/integration/updateOrderErpParameters", params);

            const { isSuccess, data, errorMessage } = response;

            setCreateLoading(false);

            if (isSuccess) {
                setIsModalVisible(false);

                toast.success("Parametreler başarılı bir şekilde güncellendi");

                props.onUpdateOrderErpParameter(fields);
            } else {
                toast.error(errorMessage);
            }
        } else {

        }
    }

    const onChangeField = (event: any) => {
        setFields({
            ...fields,
            [event.target.name]: event.target.value
        });
    }

    const onChangeFieldByName = (value: any, name: any) => {
        setFields({
            ...fields,
            [name]: value
        });
    }

    const onChangeSelectField = (name: any, value: any) => {
        setFields({
            ...fields,
            [name]: value.value
        });
    }

    const getErpValues = async () => {
        let result: ApiResponseType;
        result = await commonNetwork.get("/integration/get-erp-values");

        try {
            if (result.isSuccess) {
                const erpprojectcodeData: OptionModel[] = result.data.erpProjertCode.map((item: any) => ({
                    value: item.value,
                    label: item.label
                }));
                const erpsalesmancodeData: OptionModel[] = result.data.erpSalesmanCodes.map((item: any) => ({
                    value: item.value,
                    label: item.label
                }));
                const erpreferencecodeData: OptionModel[] = result.data.erpReferenceCodes.map((item: any) => ({
                    value: item.value,
                    label: item.label
                }))
                const erpcontractcodeData: OptionModel[] = result.data.erpContractCodes.map((item: any) => ({
                    value: item.value,
                    label: item.label
                }));
                const erpbranchcodeData: OptionModel[] = result.data.erpBranchCode.map((item: any) => ({
                    value: item.value,
                    label: item.label
                }));
                setErpprojectcodeOptions(erpprojectcodeData);
                setErpsalesmancodeOptions(erpsalesmancodeData);
                setErpreferencecodeOptions(erpreferencecodeData);
                setErpcontractcodeOptions(erpcontractcodeData);
                setErpbranchcodeOptions(erpbranchcodeData);
            } else {
                toast.error(result.errorMessage);
            }
        } catch (error) {

        }
    }
    return (
        <>
            <PaymentLinkResultModal ref={linResultModalRef} statusModalVisible={statusModalVisible} setStatusModalVisible={setStatusModalVisible}></PaymentLinkResultModal>
            <Modal openModal={isModalVisible} setOpenModal={() => setIsModalVisible(false)} >
                <div>
                    <div className="sm:flex sm:items-start">
                        <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left w-[100%]">
                            <h3 className="text-md leading-6 font-medium text-gray-900">
                                Ödeme Parametrelerini Düzenle

                            </h3>
                            <div className="flex w-100">
                                <div className="flex-auto w-50">

                                    <div className="mt-4">
                                        <Selector
                                            options={erpprojectcodeOptions}
                                            name={`erpprojectcode`}
                                            defaultValue={erpprojectcodeOptions.find((w: any) => w.value == fields.erpprojectcode)}
                                            className="w-[100%]"
                                            label="Proje Kodu"
                                            menuPortalTarget={document.body}
                                            onChange={(value: any) => onChangeSelectField("erpprojectcode", value)}
                                            placeholder="Proje Kodu Seçiniz"
                                            isClearable={true}
                                        />
                                    </div>
                                    <div className="mt-4">
                                        <Selector
                                            name={`erpsalesmancode`}
                                            className="w-[100%]"
                                            label="Satış Temsilcisi Kodu"
                                            placeholder="Satış Temsilcisi Kodu Seçiniz"
                                            menuPortalTarget={document.body}
                                            options={erpsalesmancodeOptions}
                                            defaultValue={erpsalesmancodeOptions?.find((s: any) => s.value == fields.erpsalesmancode)}
                                            onChange={(value: any) => onChangeSelectField("erpsalesmancode", value)}
                                            isClearable={true}
                                        />
                                    </div>
                                    {isNetsis ? (
                                        <>
                                            <div className="mt-4">
                                                <Selector
                                                    name={`erpreferencecode`}
                                                    className="w-[100%]"
                                                    label="Referans Kodu"
                                                    menuPortalTarget={document.body}
                                                    options={erpreferencecodeOptions}
                                                    defaultValue={erpreferencecodeOptions?.find((s: any) => s.value == fields.erpreferencecode)}
                                                    onChange={(value: any) => onChangeSelectField("erpreferencecode", value)}
                                                    placeholder="Referans Kodu Seçiniz"
                                                    isClearable={true}
                                                />
                                            </div>
                                            <div className="mt-4">
                                                <Selector
                                                    name={`erpcontractcode`}
                                                    className="w-[100%]"
                                                    label="Sözleşme Kodu"
                                                    menuPortalTarget={document.body}
                                                    options={erpcontractcodeOptions}
                                                    defaultValue={erpcontractcodeOptions?.find((s: any) => s.value == fields.erpcontractcode)}
                                                    onChange={(value: any) => onChangeSelectField("erpcontractcode", value)}
                                                    placeholder="Sözleşme Kodu Seçiniz"
                                                    isClearable={true}
                                                />
                                            </div>
                                            <div className="mt-4">
                                                <Selector
                                                    name={`erpbranchcode`}
                                                    className="w-[100%]"
                                                    label="Şube Kodu"
                                                    menuPortalTarget={document.body}
                                                    options={erpbranchcodeOptions}
                                                    defaultValue={erpbranchcodeOptions?.find((s: any) => s.value == fields.erpbranchcode)}
                                                    onChange={(value: any) => onChangeSelectField("erpbranchcode", value)}
                                                    placeholder="Şube Kodu Seçiniz"
                                                    isClearable={true}
                                                />
                                            </div>

                                        </>
                                    ) : null}
                                    <div className="mt-4">
                                        <Input
                                        type="text"
                                            name={`erpbankcode`}
                                            value={fields.erpbankcode}
                                            className="w-[100%]"
                                            label={(!isReceipt && isNetsis) ? "Kasa Kodu" : (isVirement ? "Virman Kodu" : "Banka Kodu")}
                                            onChange={(event) => {
                                                onChangeField(event)
                                            }}
                                            onChangeValue={(value) => {
                                                onChangeFieldByName(value, "erpbankcode");
                                            }}
                                            ref={bankErpCodeSelectBoxRef}
                                            // onClear={() => {
                                            //     bankErpCodeSelectBoxRef.current.setValue("");
                                            // }}
                                            // cleareble
                                            isError={false}
                                            error={fields.erpbankcode?.length > 50 ? "Banka Kodu en fazla 20 karakter olabilir." : null}
                                            maxLength={51}
                                            rightOutsideIcon={isLogoAppProject() &&
                                                <div className="flex items-center" >
                                                    <TbDots
                                                        onClick={() => openBankListForm()}
                                                        className="justify-end sm:block h-6 w-6 text-black hidden cursor-pointer  "
                                                        aria-hidden="true"
                                                        color="#0090FF"
                                                    />
                                                </div>
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="mt-5 mt-4 flex justify-end space-x-2">
                        <Button
                            color="gray"
                            hover="gray"
                            size="xs"
                            callback={() => setIsModalVisible(false)}
                        >
                            İptal
                        </Button>
                        <Button
                            color="primary"
                            hover="primary"
                            size="xs"
                            loading={createLoading}
                            disabled={createLoading}
                            callback={() => {
                                onUpdateClick();
                            }}
                        >
                            Kaydet
                        </Button>
                    </div>
                </div>
            </Modal>

        </>
    );
})

export default UpdateOrderErpParametersModal;